import React, { useState, useEffect, useMemo } from 'react';
import "./IndividualRegistrationModal.css";
import close from "../../../../../../assets/close.svg";
import axiosApi from "../../../../../../core/interceptor/interceptor";
import { messages } from "../../../../../../messages.js";
import { config } from "../../../../../../config";
import { teamsPreferredTime, validateRequiredFields } from "../../../../../../Util/helper";
import CustomSelect from '../../../../../../Util/CustomSelect/CustomSelect';
export default function AddTeamLeague(props) {
    const leagueList = useMemo(() => {
        const temp = [];
        return props.leagues.filter(x => {
            if (x && temp.indexOf(x.id) === -1) {
                temp.push(x.id);
                return true;
            }
            return false;
        });
    }, [props.leagues]);
    const [open, setOpen] = useState(false);
    const [preferredTime, setPreferredTime] = useState(null);
    const [seasons, setSeasons] = useState([]);
    const [selectedIndex, setSelectedIndex] = useState(null);
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        league_id: props.leagueId || 0,
        preferred_time: '',
        indv_reg_ids: props.indvRegIds,
        team_id: 0,
        send_payment_link_ids: []
    });
    const [errors, setErrors] = useState({
        preferred_time: '',
        name: '',
    });
    const [teamsList, setTeamsList] = useState([]);
    const [individualSendLink, setIndividualSendLink] = useState([]);

    useEffect(() => {
        handleValidation();
        //eslint-disable-next-line
    }, [formData]);

    useEffect(() => {
        if (props.assignTeam && props.leagueId > 0) {
            getTeams(props.leagueId);
        }
    }, [props.assignTeam]);

    useEffect(() => {
        if (props.indvRegIds && props.indvRegIds.length > 0) {
            getIndividualRegistration(props.indvRegIds);
        }
    }, [props.indvRegIds]);

    useEffect(() => {
        if (leagueList?.length === 1 && !props.leagueId) {
            setFormData((prev) => 
                ({
                    ...prev,
                    league_id: leagueList[0].id,
                    league_name: leagueList[0].name,
                })
            );
            getTeams(leagueList[0].id);
        }
    }, [leagueList, props.leagueId])
    /*** closes modal *****/
    const closeModal = () => {
        if (props.closeModal) {
            props.closeModal();
        }
    }

    const handleFormChange = (event, number = false) => {
        setFormData((previousFormData) => ({
            ...previousFormData,
            [event.target.name]: number ? Number(event.target.value) : event.target.value,
        }))
    }

    const handleCheckbox = (e) => {
        if (e.target.checked) {
            setFormData((prev) => {
                return {
                    ...prev,
                    send_payment_link_ids: [...new Set([...prev.send_payment_link_ids, e.target.value])]
                }
            });
        } else {
            const index = formData.send_payment_link_ids.findIndex( x => x === e.target.value);
            if (index !== -1) {
                setFormData((prev) => {
                    return {
                        ...prev,
                        send_payment_link_ids: prev.send_payment_link_ids.splice(index, 1)
                    }
                });
            }
        }
    }

    const handleValidation = () => {
        let errorArr = {};
        /***** name validation ******/
        if (!formData['name']?.trim()) {
            errorArr["name"] = messages && messages.emptyTeamName;
        }
        if (!formData['preferred_time']) {
            errorArr["preferred_time"] = messages && messages.emptyTime;
        }
        if (props.assignTeam && !formData['team_id']) {
            errorArr['team_id'] = messages && messages.selectTeam;
        }
        setErrors(errorArr);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setFormSubmitted(true);
        const payload = { ...formData };
        if (props.assignTeam) {
            delete payload.league_id;
            delete payload.name;
            delete payload.preferred_time;
            if (!payload?.send_payment_link_ids?.length) {
                delete payload.send_payment_link_ids;
            }
        } else {
            delete payload.team_id;
            if (!payload?.send_payment_link_ids?.length) {
                delete payload.send_payment_link_ids;
            }
        }
        if (!validateRequiredFields(payload)) {
            const data = { ...payload };
            if (data) {
                data.name = data.name?.trim();
            }
            if (props.assignTeam) {
                axiosApi.post(`${config.apiUrl}/teams/assign-team`, data)
                .then((res) => {
                    setFormSubmitted(true);
                    props.reloadPage();
                    closeModal();
                })
                .catch((error) => {
                    if (props.indvRegIds && props.indvRegIds.length > 0) {
                        getIndividualRegistration(props.indvRegIds);
                    }
                });
            } else {
                axiosApi.post(`${config.apiUrl}/teams`, data)
                    .then(() => {
                        setFormSubmitted(true);
                        props.reloadPage();
                        closeModal();
                    })
                    .catch((error) => {
                        if (props.indvRegIds && props.indvRegIds.length > 0) {
                            getIndividualRegistration(props.indvRegIds);
                        }
                    });
            }
        }
    }

    const onSelect = (data, type = 'preferred_time') => {
        if (data && data.title) {
            setFormData((previousFormData) => {
                return {
                    ...previousFormData,
                    [type]: data.id,
                }
            });
            setPreferredTime(data.title);
        }
    }

    const getTeams = (id) => {
        axiosApi.get(`${config.apiUrl}/teams/list/${id}?status=active`).then((resp) => {
            if (resp && resp.data && resp.data.data) {
                setTeamsList(resp.data.data);
                // setLeagueList(resp.data.data);
            }
        }).catch((err) => {
            console.error(err);
        });
    }

    const getIndividualRegistration = (ids) => {
        axiosApi.get(`${config.apiUrl}/teams/check-individual-payment-link?id=${ids}`).then((resp) => {
            if (resp && resp.data && resp.data.data) {
                setIndividualSendLink(resp.data.data);
            }
        }).catch((err) => {
            console.error(err);
        });
        
    }
    return <>
        {open ? <div className="modal season-popup">
            <div className="modal-header">
                <h2>Change Season</h2>
                <p>Select a season</p>
                <span className="close" onClick={() => setOpen(o => !o)}>
                    <img src={close} alt='close-icon' />
                </span>
            </div>
            <div className="modal-body modal-body-seasons">
                {
                    seasons.length
                        ? seasons.map((season, index) => (
                            <div className={`inner-blk ${index === selectedIndex && 'active'}`}
                                onClick={
                                    () => {
                                        setSelectedIndex(index);
                                    }
                                }>
                                <span>{season.name}</span>
                            </div>))
                        : <div className="noSeason">No record found.</div>
                }
            </div>
            <div className="modal-footer d-flex">
                <button type="button" className="cancel-btn" onClick={() => setOpen(o => !o)}>Cancel</button>
                <button onClick={() => { }}>Confirm</button>
            </div>
        </div> :
            <div className="modal">
                <div className="modal-header">
                    <h2>{props.assignTeam ? 'Assign' : 'Add'} Team</h2>
                    <p>{props.assignTeam ? 'Select team to assign players' : 'Enter team details'}</p>
                    <span className="close" onClick={closeModal}>
                        <img src={close} alt='close-icon' />
                    </span>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="addTeam-Modal">
                    {
                                !props.leagueId && leagueList?.length > 0 && 
                                <div className="input-wrapper">
                                    <CustomSelect
                                        required={true}
                                        data={leagueList}
                                        label="Select League"
                                        placeholder={formData && formData.league_id ? formData.league_name : 'Select League'}
                                        selector="name"
                                        onSelect={(e) => e && e.id && setFormData((previousFormData) => {
                                            if (props.assignTeam) {
                                                getTeams(e.id);
                                            }
                                            return {
                                                ...previousFormData,
                                                league_id: e.id,
                                                league_name: e.name,
                                                team_id: 0,
                                                name: '',
                                            }
                                        })}
                                    />
                                    {formSubmitted && <span className="error">{errors["league_id"]}</span>}
                                </div>
                            }
                        {!props.assignTeam ? <><div className="input-field">
                            <label>Team Name<sup>*</sup></label>
                            <input type="text" name="name" placeholder="" onChange={handleFormChange} />
                            {formSubmitted && <span className="error">{errors["name"]}</span>}
                        </div>
                            <div className="input-wrapper">
                                <CustomSelect
                                    required={true}
                                    data={teamsPreferredTime.preferred_time}
                                    label="Preferred Time"
                                    placeholder={preferredTime ? preferredTime : 'Select preferred time'}
                                    selector="title"
                                    onSelect={onSelect}
                                />
                                {formSubmitted && <span className="error">{errors["preferred_time"]}</span>}
                            </div>
                        </> : 
                        <>
                            <div className="input-wrapper">
                                <CustomSelect
                                    required={true}
                                    data={teamsList}
                                    label="Teams"
                                    placeholder={formData && formData.team_id ? formData.name : 'Select Team'}
                                    selector="name"
                                    onSelect={(e) => e && e.id && setFormData((previousFormData) => {
                                        return {
                                            ...previousFormData,
                                            team_id: e.id,
                                            name: e.name
                                        }
                                    })}
                                />
                                {formSubmitted && <span className="error">{errors["team_id"]}</span>}
                            </div>
                        </>}
                        {
                        individualSendLink.length > 0 && (
                            <div className='check-box-section'>
                                <div>
                                {
                                    individualSendLink.map((x, i) => (
                                        <>
                                            <label class="cs-custom-checkbox" for="captain">
                                                <input type="checkbox" id="captain"   name={`'individual-send-link-${i}`} onChange={(e) => handleCheckbox(e)} value={x.id} />
                                                <span></span>{x.user.full_name}
                                            </label>
                                        </>
                                    ))
                                }
                                </div>
                                <div className='individual-warning-msg'> Note: Payment for the individual has failed. Please mark the checkbox to send a payment link to the user. If you prefer to collect the payment manually, do not mark the checkbox.</div>
                            </div>
                        )
                        }
                    </div>
                    
                    
                    <div className="modal-footer d-flex">
                        <button className="cancel-btn" onClick={closeModal}>Cancel</button>
                        <button type="submit">Confirm</button>
                    </div>
                </form>
            </div>
        }
    </>
}